// import React from 'react'

// const PurchaseApprovalPending = () => {
//   return (
//     <div>PurchaseApprovalPending</div>
//   )
// }

// export default PurchaseApprovalPending



import { Grid } from "@mui/material";
import CustomTable from "../../../Components/Table/CustomTable";

import { useDispatch, useSelector } from "react-redux";
import { setHeaderName } from "../../../ReduxStore/Slices/headerSlice";
// import TableDataViewModal from "../Modal/TableDataViewModal";
import actions from "../../../ReduxStore/actions";
import TableDataViewModal from "../../Operator/Modal/TableDataViewModal";
import PurchaseApprovalModalView from "./Modal/PurchaseApprovalModalView";
import { format } from "date-fns";
import { useEffect, useState } from "react";
// import { setHeaderName } from './headerSlice';

const PurchaseApprovalPending = ({ setHeaderTitleName }) => {
  //   const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  //   const UserRole = sessionStorage.getItem("UserRole");

  //    const customerId = useSelector((state) => state.customer);

  //    console.log(customerId,"customerIdcustomerIdcustomerIdcustomerId");


  //   const { managementRegisterForCustomer } = useSelector(
  //     (state) => state?.managementRegisterForCustomer
  //   );
  //   const dispatch = useDispatch();
  //   const { getCustomersByCreator } = useSelector(
  //     (state) => state?.getCustomersByCreator
  //   );

  // console.log(getCustomersByCreator,"getCustomersByCreatorgetCustomersByCreator")

  //   useEffect(() => {
  //     const data1 = {
  //       data: {
  //         createdByUserId: sessionOperator_id,
  //         createdByUserRole: UserRole,
  //       },
  //       method: "get",
  //       apiName: "getCustomersByCreator",
  //     };

  //     dispatch(actions.GETCUSTOMERSBYCREATOR(data1));
  //   }, [managementRegisterForCustomer]);

  //   const [rowTableData, setRowTableData] = useState([
  //     {
  //       Name: "--",
  //       CustomerId:"--",
  //       Email: "--",
  //       MobileNumber: "--",
  //       UserType: "--",
  //       Status: "--",
  //     },
  //   ]);
  //   console.log(rowTableData, "rowTableDatarowTableData");
  //   useEffect(() => {
  //     const tempArr = [];
  //     getCustomersByCreator?.data?.map((data, index) => {
  //       return tempArr.push({
  //         Name: `${data?.first_name} ${data?.last_name}` || "--",
  //         customer_id:data?.customer_id || "--",
  //         Email: data?.email || "--",
  //         MobileNumber: data?.phone || "--",
  //         UserType: data?.role ? data?.role : "--",
  //         Status:
  //           data?.approval_status === "pending"
  //             ? "Pending"
  //             : data?.approval_status === "approved"
  //             ? "Approved"
  //             : "Unknown" || "--", // Add a default case if needed

  //       });   
  //     });
  //     setRowTableData(tempArr);
  //   }, [dispatch, getCustomersByCreator]);


  //   useEffect(() => {
  //     // setHeaderTitleName("User Registration")
  //     dispatch(setHeaderName("User Registration"));
  //   }, []);
  const tableData = [
    {
      Name: "Vallarasu",

      Email: "valla@gmail.com",
      PurchaserName: "Scheme 1,Scheme 2",
      PurchaseDate: "15 Jan 2025",
      Maturity: "15 Jan 2025",
    },
    {
      Name: "Pravin",
      Email: "pravin@gmail.com",
      PurchaserName: "Scheme 1,Scheme 2",
      PurchaseDate: "15 Jan 2025",
      Maturity: "15 Jan 2025",
    },
    {
      Name: "Shahul",
      Email: "shahul@gmail.com",
      PurchaserName: "Scheme 1,Scheme 2",
      PurchaseDate: "15 Jan 2025",
      Maturity: "15 Jan 2025",


    },
    {
      Name: "Ramesh",
      Email: "Ramesh@gmail.com",
      PurchaserName: "Scheme 1,Scheme 2",
      PurchaseDate: "15 Jan 2025",
      Maturity: "15 Jan 2025",


    },
    {
      Name: "Sanjeev",
      Email: "Sanjeev@gmail.com",
      PurchaserName: "Scheme 1,Scheme 2",
      PurchaseDate: "15 Jan 2025",
      Maturity: "15 Jan 2025",

    },
  ];



  const dispatch = useDispatch();
  const { getAllPendingPurchasesWithCreator } = useSelector(
    (state) => state?.getAllPendingPurchasesWithCreator
  );


  // const { approvePlan } = useSelector((state) => state?.approvePlan);


  console.log(getAllPendingPurchasesWithCreator, "getAllPendingPurchasesWithCreatorgetAllPendingPurchasesWithCreator")


   const { approvePurchase } = useSelector((state) => state?.approvePurchase);

  useEffect(() => {
    const data1 = {
      data: {},
      method: "get",
      apiName: "getAllPendingPurchasesWithCreator",
    };

    dispatch(actions.GETALLPENDINGPURCHASESWITHCREATOR(data1));
  }, [approvePurchase]);


  const [rowTableData, setRowTableData] = useState([
    {
      Name: "--",
      email: "--",
      phone: "--",
      title: "--",
      stake_starting: "--",
      stake_maturity: "--",
      Status: "--",
    },
  ]);
  //   console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {
    const tempArr = [];
    getAllPendingPurchasesWithCreator?.data?.map((data, index) => {
      return tempArr.push({
        Name: `${data?.customer?.first_name} ${data?.customer?.last_name}`,
        purchase_id:data?.purchase_id,
        email: data?.customer?.email,
        phone: data?.customer?.phone,
        title: data?.title,
        stake_starting: format(new Date(data?.stake_starting), 'MMMM d, yyyy'),
        stake_maturity: format(new Date(data?.stake_maturity), 'MMMM d, yyyy'),
        Status: `${data?.approval_status}`,
      });
    });
    setRowTableData(tempArr);
  }, [dispatch,getAllPendingPurchasesWithCreator,approvePurchase]);


  const tableHeadData = [
    "S.No",
    "Purchaser Name",
    "Purchaser Email",
    "Purchaser Phone",
    "Scheme Name",
    "Purchase Date",
    "Maturity",
    "Status"
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          title="User List"
          tableHeadData={tableHeadData}
          //   modalName={UserCreateByOperatorModal}
          allShowModal="allShowModal"
          modalVeiwName={PurchaseApprovalModalView}
          //   notModalTable="notModalTable"
          //   tableEdit="tableEdit"
          tableView="tableView"
          modalViewHeadingName="Purchaser Detail"
          modalHeadingName="Create User"
          // dataCreate="dataCreate"
          IsShowRejectApproveButton="IsShowRejectApproveButton"
        />
      </Grid>
    </Grid>
  );
};

export default PurchaseApprovalPending;
